export enum AppointmentStatus {
  ACTIVE = 'active',
  CONFIRMED = 'confirmed',
  CANCELED = 'canceled',
}
